import _ from "lodash";
import moment from "../../plugins/moment";

import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";
import * as ACTION_TYPES from "./action-types";
import { getFlightDurationText, round } from "../../pages/nights/helpers";
import { GET_FLEX_EXTRA_SELECTED } from "../booking/getter-types";
import setTypeDay from "../../utils/setTypeDay";

const passengerData = () => ({
  name: "",
  last_name: "",
  email: "",
  date_of_birth: "",
  card_id_type: "",
  card_id: "",
  phone_prefix: "",
  phone: "",
  nationality: "",
  bags: [],
  age: ""
});

const initialState = () => ({
  resources: {
    origins: [],
    destinations: [],
    hotels: [],
    flights: [],
    returnFlights: [],
    extras: [],
    destinationCards: [],
    bags: [
      {
        id: 1,
        name: "Bolsa de mano",
        description:
          "Bolsa o mochila de 35 x 25 x 20cm. Puedes llevar una pieza de equipaje que quepa bajo el asiento delantero.",
        included: true,
        price: 0,
        icon: "icons-extra-bag.svg"
      },
      {
        id: 2,
        name: "Maleta de mano",
        description: "10Kg",
        included: false,
        price: 54.95,
        icon: "suitcase-2.svg"
      },
      {
        id: 3,
        name: "Equipaje facturado",
        description: "20Kg",
        included: false,
        price: 89.95,
        icon: "luggage-2.svg"
      }
    ]
  },
  contact:{
    email: '',
    phone: '',
    prefix_phone: ''
  },
  packAvmContact: {
    name: '',
    lastName: '',
    phone: '',
    street: '',
    floor: '',
    postalCode: '',
    city: '',
    country: 'España',
  },
  hotel: {},
  hotelSetFromCode: false, // Hotel set from "hotel" query param
  start: "",
  end: "",
  adults: 0,
  children: 0,
  childrenAges: '', // separated by '-'
  babies: 0,
  babiesAges: '', // separated by '-'
  origin: {},
  destination: {},
  flight: {},
  extras: [],
  passengers: [],
  rooms: 1,
  newsletter: false,
  discountCode: "",
  loading: false,
  showOverlay: false,
  packHotels: [],
  totalPrice:null,
  totalPriceHotelPack: null,
  totalPriceHotelPackLuxury: null,
  luxuryExtra:null,
  extraNoPromoPrice: 0,
  selectedCategory: {
    name:"standard",
    hotels: []
  },
  reservationId: null,
  packFlights: [],
  pack: true,
  bundlePrice: 0,
  selectedFlights: {
    journey: {},
    return: {}
  },
  flightSelector: 'journey',
  itineraries: []
});
export const nightsState = {
  nights: initialState()
};

export const nightsGetters = {
  [GETTER_TYPES.GET_EXTRA_NO_PROMO_PRICE](state) {
    return state.nights.extraNoPromoPrice
  },
  [GETTER_TYPES.GET_DESTINATION_CARDS](state) {
    return state.nights.resources.destinationCards;
  },

  [GETTER_TYPES.GET_FLIGHT_SELECTOR](state) {
    return state.nights.flightSelector
  },
  [GETTER_TYPES.NIGHTS_GET_ITINERARY](state) {
    return state.nights.itinerary
  },
  [GETTER_TYPES.NIGHTS_GET_IS_PACK_FLIGHT](state) {
    return state.nights.pack;
  },
  [GETTER_TYPES.NIGHTS_GET_PACK_HOTELS](state) {
    return state.nights.packHotels;
  },
  [GETTER_TYPES.NIGHTS_GET_INTERN_FLIGHTS](state) {
    let totalInternalFlightsPrice = 0;
    if (state.nights.resources.internFlights && state.nights.resources.internFlights.length > 0) {
      state.nights.resources.internFlights.forEach(flight => {
          totalInternalFlightsPrice += flight.price;
      });
    }
    return totalInternalFlightsPrice;
  },
  [GETTER_TYPES.NIGHTS_GET_SELECTED_CATEGORY](state) {
    return state.nights.selectedCategory;
  },
  [GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY] (state) {
    return state.nights.totalPriceHotelPackLuxury;
  },
  [GETTER_TYPES.NIGHTS_GET_LUXURY_EXTRA] (state) {
    return state.nights.luxuryExtra;
  },
  [GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD] (state) {
    return state.nights.totalPriceHotelPack;
  },
  [GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE_PACK_HOTELS](state, getters) {
    const selectedCategory = getters[GETTER_TYPES.NIGHTS_GET_SELECTED_CATEGORY];
    const totalPriceHotelPack = getters[GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE_PACK_STANDARD];
    const totalPriceHotelPackLuxury = getters[GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE_PACK_LUXURY];

    if (selectedCategory.name === 'standard') {
      return totalPriceHotelPack;
    } else if (selectedCategory.name === 'luxury') {
      return totalPriceHotelPackLuxury;
    } else {
      return 0;
    }
  },

  [GETTER_TYPES.GET_PACK_FLIGHTS](state) {
    return state.nights.packFlights;
  },
  [GETTER_TYPES.GET_TYPE_PACK_DATES](state, getters) {
    return getters[GETTER_TYPES.GET_PACK_FLIGHTS].map((days, index) => {
      if (days[1] && days[1][0]) {
        const price = days[1][0].price;
        const type = setTypeDay(price, state.destinies.trip);
        return {
          id: index,
          day: days[0],
          price: price.toFixed(2),
          type: type
        };
      }
    }).filter(Boolean);
  },
  [GETTER_TYPES.GET_RESERVATION_ID](state) {
    return state.nights.reservationId;
  },
  [GETTER_TYPES.NIGHTS_GET_QUERY_PARAMS](state) {
    const { start, end, adults, children, babies, itinerary } = state.nights;
    const reservationId = state.nights.reservationId;
    const params = { start, end, adults, children, babies, itinerary };
    if (state.nights.hotelSetFromCode) {
      params.hotel = state.nights.hotel.code;
    }

    if(reservationId) {
      params.reservationId = reservationId;
    }

    return params;
  },
  [GETTER_TYPES.NIGHTS_GET_PASSENGERS_COUNT](state) {
    return state.nights.adults + state.nights.children + state.nights.babies;
  },
  [GETTER_TYPES.NIGHTS_GET_MIN_ROOMS](state, getters) {
    return 1;
  },
  [GETTER_TYPES.NIGHTS_GET_NIGHTS](state) {
    const { start, end } = state.nights;
    if (!start || !end) return 0;
    return moment(end).diff(moment(start), "days");
  },
  [GETTER_TYPES.NIGHTS_GET_CHEAPEST_FLIGHT_TO_DESTINATION]: state => destination => {
    const prices = state.nights.resources.flights
      .filter(({ cityCodeTo }) => cityCodeTo === destination.code)
      .map(({ price }) => price);
    return _.min(prices);
  },

  [GETTER_TYPES.NIGHTS_GET_RATE_PRICE]: () => rate => {
    return parseFloat(rate.net);
  },
  [GETTER_TYPES.NIGHTS_GET_HOTEL_PRICE]: (state, getters) => hotel => { // Any hotel, not selected one
    return round(hotel.totalNet);
  },
  [GETTER_TYPES.NIGHTS_GET_SELECTED_HOTEL_PRICE](state, getters) {
    const { hotel } = state.nights;
    if (_.isEmpty(hotel)) return 0;
    return round(hotel.price);
  },
  [GETTER_TYPES.NIGHTS_GET_HOTEL_RATE_COMMENTS](state, getters) {
    if (_.isEmpty(state.nights.hotel) || !state.nights.hotel.rateComments) {
      return [];
    }

    return _.uniq(
      state.nights.hotel.rateComments
        .map(({ description }) => description)
    );
  },
  [GETTER_TYPES.NIGHTS_GET_EXTRA_BY_ID]: state => extraId => {
    return state.nights.resources.extras.find(({ id }) => id === extraId);
  },
  [GETTER_TYPES.NIGHTS_GET_SELECTED_EXTRA_BY_ID]: state => extraId => {
    return state.nights.extras.find(({ id }) => id === extraId);
  },
  [GETTER_TYPES.NIGHTS_GET_EXTRA_UNIT_PRICE]: (state, getters) => extraId => {
    const extra = getters[GETTER_TYPES.NIGHTS_GET_EXTRA_BY_ID](extraId);
    return extra.pivot ? extra.pivot.price : extra.price;
  },
  [GETTER_TYPES.NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY]: (
    state,
    getters
  ) => extraId => {
    const extra = getters[GETTER_TYPES.NIGHTS_GET_SELECTED_EXTRA_BY_ID](
      extraId
    );

    const { one_per_passenger, has_counter } = extra;
    let quantity;

    if (one_per_passenger) {
      quantity = getters[GETTER_TYPES.NIGHTS_GET_PASSENGERS_COUNT];
    } else {
      quantity = has_counter ? extra.quantity : 1;
    }

    const price =
      getters[GETTER_TYPES.NIGHTS_GET_EXTRA_UNIT_PRICE](extraId) *
      quantity;

    return round(price);
  },
  [GETTER_TYPES.NIGHTS_GET_ALL_EXTRAS_PRICE](state, getters) {
    const price = state.nights.extras.reduce((total, extra) => {
      return (
        total +
        getters[GETTER_TYPES.NIGHTS_GET_EXTRA_PRICE_TIMES_QUANTITY](extra.id)
      );
    }, 0);
    return round(price);
  },
  [GETTER_TYPES.NIGHTS_GET_BAGS_PRICE_FOR_ALL_PASSENGERS](state) {
    const price = state.nights.passengers.reduce(
      (total, passenger) =>
        total + passenger.bags.reduce((total, bag) => total + bag.price, 0),
      0
    );
    return round(price);
  },
  [GETTER_TYPES.NIGHTS_GET_BAGS_SUMMARY_INFO](state) {
    const initialArray = state.nights.resources.bags.map(bag => ({
      ...bag,
      quantity: 0,
      totalPrice: 0,
    }));
    const bagsInfo = state.nights.passengers.reduce((agg, passenger) => {
      for (let bag of passenger.bags) {
        const bagToUpdate = agg.find(({ id }) => id === bag.id);
        bagToUpdate.quantity++;
        bagToUpdate.totalPrice = round(bagToUpdate.totalPrice + bag.price);
      }
      return agg;
    }, initialArray);
    return bagsInfo.filter(bag => bag.quantity !== 0);
  },
  [GETTER_TYPES.GET_NIGHTS_TOTAL_PRICE_WITH_DISCOUNT](state, getters) {
    const price =
      getters[GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE] -
      getters[GETTER_TYPES.GET_NIGHTS_DISCOUNT];
    return price < 0 ? 0 : round(price);
  },
  tripPrice (state, getters) {
    return state.nights.flight.price+ state.nights.bundlePrice;

  },
  [GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE](state, getters) {
    let flexExtraTotal = 0;
    let price = getters['tripPrice'];
    if(getters[GET_FLEX_EXTRA_SELECTED]){
      price += getters[GET_FLEX_EXTRA_SELECTED].price;
    }

    if (state.nights.selectedCategory.name === 'luxury') {
      price += getters['flexExtraTotal'];
    }
    return round(price);
  },
  [GETTER_TYPES.GET_NIGHTS_DISCOUNT_CODE](state) {
    return state.nights.discountCode;
  },
  [GETTER_TYPES.GET_NIGHTS_DISCOUNT_CODE_IS_APPLICABLE](state, getters) {
    if (!state.nights.discountCode) return false;

    switch (state.nights.discountCode.requirements) {
      case "monto":
        return (
          getters[GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE] >=
          state.nights.discountCode.req_qty
        );
      case "none":
        return true;
    }
  },

  [GETTER_TYPES.GET_NIGHTS_DISCOUNT](state, getters) {
    if (
      !state.nights.discountCode ||
      !getters[GETTER_TYPES.GET_NIGHTS_DISCOUNT_CODE_IS_APPLICABLE]
    )
      return 0;

    const { type, value_discount } = state.nights.discountCode;

    switch (type) {
      case "percent":
        return round(
          (getters[GETTER_TYPES.NIGHTS_GET_TOTAL_PRICE] / 100) * value_discount
        );
      case "fixprice":
        return value_discount;
    }
    flexExtraTotal = getters[GET_FLEX_EXTRA_SELECTED].price;
  },
  flexExtraTotal(state, getters){
    return getters[GETTER_TYPES.NIGHTS_GET_LUXURY_EXTRA] * getters[GETTER_TYPES.NIGHTS_GET_PASSENGERS_COUNT];
  }

};

export const nightsMutations = {
  [MUTATION_TYPES.NIGHTS_SET_EXTRA_NO_PROMO_PRICE](state, payload) {
    state.nights.extraNoPromoPrice = payload;
  },
  SET_ITINERARIES(state, itineraries) {
      state.itineraries = itineraries;
  },
  [MUTATION_TYPES.SET_DESTINATION_CARDS](state, payload) {
    state.nights.resources.destinationCards = payload;
  },

  [MUTATION_TYPES.SET_FLIGHT_SELECTOR](state, payload) {
    state.nights.flightSelector = payload;
  },
  [MUTATION_TYPES.RESOURCES_BAGS_CALUCLATE](state, hotels) {
    state.hotels = hotels;
  },

  [MUTATION_TYPES.SET_INTERCONTINENTAL_FLIGHTS](state, payload) {
    state.nights.packFlights = [...payload];
  },
  [MUTATION_TYPES.SET_RESERVATION_ID](state, payload) {
    state.nights.reservationId = payload;
  },
  [MUTATION_TYPES.SET_CONTACT_DATA](state, payload) {
    state.nights.contact = {...payload};
  },
  [MUTATION_TYPES.SET_CONTACT_PACK_AVM](state, payload) {
    state.nights.packAvmContact = {...payload};
  },
  [MUTATION_TYPES.RESOURCES_BAGS_CALUCLATE](state) {
    // let flights = state.nights.flight.airlines.filter((el) => el == 'FR' );
    // state.nights.resources.bags[1].price = 10 * flights.length;
  },
  [MUTATION_TYPES.SET_NIGHTS_DISCOUNT_CODE](state, payload) {
    state.nights.discountCode = payload;
  },
  [MUTATION_TYPES.NIGHTS_SET_RESOURCES](state, [prop, value]) {
    state.nights.resources[prop] = value;
  },
  [MUTATION_TYPES.NIGHTS_SET_PACK](state, payload) {
    state.nights.pack = payload;
  },

  [MUTATION_TYPES.NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS](state, destinations) {
    state.nights.resources.destinations = destinations;
  },
  [MUTATION_TYPES.NIGHTS_RESET_STATE](state) {
    state.nights = initialState();
  },
  [MUTATION_TYPES.NIGHTS_SET_STATE](state, payload) {
    if (Array.isArray(payload[0])) {
      for (const [prop, value] of payload) {
        state.nights[prop] = value;
      }
    } else {
      const [prop, value] = payload;
      state.nights[prop] = value;
    }
  },
  [MUTATION_TYPES.NIGHTS_SET_FLIGHT](state, payload) {
    state.nights.flight = payload;
  },
  [MUTATION_TYPES.NIGHTS_SET_HOTEL](state, hotel) {
    const { address, categoryCode, code, name, price, rateComments, rooms, distance } = hotel;
    const image = `http://photos.hotelbeds.com/giata/${hotel.images[0].path}`;
    const category = Number(categoryCode.replace(/(LUX)|(EST)/, ''));
    state.nights.hotel = { address, category, categoryCode, code, name, price, rateComments, rooms, image, distance };
  },
  [MUTATION_TYPES.NIGHTS_TOGGLE_EXTRA](state, extraId) {
    const extra = _.cloneDeep(
      state.nights.resources.extras.find(({ id }) => id === extraId)
    );
    const index = state.nights.extras.findIndex(({ id }) => id === extraId);
    if (index === -1) {
      extra.quantity = extra.one_per_passenger
        ? state.nights.adults + state.nights.children + state.nights.babies
        : 1;
      state.nights.extras = [...state.nights.extras, extra];
    } else {
      state.nights.extras = [
        ...state.nights.extras.slice(0, index),
        ...state.nights.extras.slice(index + 1)
      ];
    }
  },
  [MUTATION_TYPES.NIGHTS_SET_EXTRA_QUANTITY](state, { quantity, extraId }) {
    const extra = state.nights.extras.find(({ id }) => id === extraId);
    extra.quantity = quantity;
  },
  [MUTATION_TYPES.NIGHTS_SET_PASSENGERS_ARRAY](state) {
    const types = [
      ["adult", "adults"],
      ["child", "children"],
      ["baby", "babies"]
    ];
    let id = 1;
    state.nights.passengers = types.reduce((agg, [singular, plural]) => {
      const passengersOfType = Array.from({ length: state.nights[plural] }).map(
        () => {
          return {
            id: id++,
            type: singular,
            ...passengerData()
          };
        }
      );
      return [...agg, ...passengersOfType];
    }, []);
  },
  [MUTATION_TYPES.NIGHTS_SET_PASSENGER_DATA](state, { passengerId, data }) {
    state.nights.passengers = state.nights.passengers.map(passenger => {
      if (passenger.id === passengerId) {
        return { ...passenger, ...data };
      }
      return passenger;
    });
  },
  [MUTATION_TYPES.NIGHTS_TOGGLE_PASSENGER_BAG](state, { passengerId, bagId }) {
    const passenger = state.nights.passengers.find(
      ({ id }) => id === passengerId
    );
    const bag = _.cloneDeep(
      state.nights.resources.bags.find(({ id }) => id === bagId)
    );
    const index = passenger.bags.findIndex(({ id }) => id === bagId);
    if (index === -1) {
      passenger.bags = [...passenger.bags, bag];
    } else {
      passenger.bags = [
        ...passenger.bags.slice(0, index),
        ...passenger.bags.slice(index + 1)
      ];
    }
  },
  [MUTATION_TYPES.NIGHTS_SET_PACK_HOTELS](state,payload) {
    state.nights.packHotels = payload;
  },
  [MUTATION_TYPES.NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_STANDARD](state, payload) {
    state.nights.totalPriceHotelPack = payload;
  },
  [MUTATION_TYPES.NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_LUXURY](state, payload) {
    state.nights.totalPriceHotelPackLuxury = payload;
  },
  [MUTATION_TYPES.NIGHTS_SET_LUXURY_EXTRA](state, payload) {
    state.nights.luxuryExtra = payload;
  },
  [MUTATION_TYPES.NIGHTS_SET_SELECTED_CATEGORY](state, payload) {
    state.nights.selectedCategory = payload;
  },
  setBundlePrice(state, payload) {
    state.nights.bundlePrice = payload;
  },
  [MUTATION_TYPES.UPDATE_PACK_FLIGHT](state, payload){
    state.nights.packFlights[payload.index][1][0].price = payload.price;
  },
  [MUTATION_TYPES.SET_JOURNEY_FLIGHT](state, payload) {
    state.nights.selectedFlights.journey = payload;
  },
  [MUTATION_TYPES.SET_RETURN_FLIGHT](state, payload) {
    state.nights.selectedFlights.return = {...payload};
  }
};

export const nightsActions = {
  [ACTION_TYPES.FETCH_INTERCONTINENTAL_FLIGHTS]({ commit}, {origin, destiny, adults, children, babies, itinerary}) {
    axios.get(
      `/api/flights/${origin}/${destiny}?adults=${adults}&children=${children}&infants=${babies}&itinerary=${itinerary}`
    ).then(({ data }) => {
      commit(MUTATION_TYPES.SET_INTERCONTINENTAL_FLIGHTS, Object.entries(data));
    })
  },
  [ACTION_TYPES.NIGHTS_SET_DATA_FROM_QUERY_PARAMS]({ commit, getters }, query) {
    const { start, end, adults, children, babies, itinerary } = query;
    const momentStart = moment(start);
    const momentEnd = moment(end);
    if (
      !(
        momentStart.isValid() &&
        momentEnd.isValid() &&
        momentStart.isBefore(momentEnd)
      ) ||
      isNaN(+adults) ||
      adults <= 0 ||
      isNaN(+children) ||
      isNaN(+babies)
    ) {
      throw new Error("Invalid query params");
    }
    commit(MUTATION_TYPES.NIGHTS_SET_STATE, [
      ["start", start],
      ["end", end],
      ["adults", Number(adults)],
      ["children", Number(children)],
      ["babies", Number(babies)],
      ["itinerary", Number(itinerary || 0)],
      ["journey", true],
    ]);
    commit(MUTATION_TYPES.NIGHTS_SET_PASSENGERS_ARRAY);
    commit(MUTATION_TYPES.NIGHTS_SET_STATE, [
      "rooms",
      getters[GETTER_TYPES.NIGHTS_GET_MIN_ROOMS]
    ]);
  },
  async [ACTION_TYPES.NIGHTS_FETCH_AND_SET_INITIAL_DATA](
    { commit, dispatch, state },
    route
  ) {
    const { resources } = state.nights;
    if (!resources.flights.length || !resources.destinations.length) {
      const originCode = route.params.origin;
      const destinationCode = route.params.destination;
      let [{ data: origins }, flights] = await Promise.all([
        dispatch(ACTION_TYPES.NIGHTS_FETCH_ORIGINS_WITH_DESTINATIONS, originCode),
        dispatch(ACTION_TYPES.NIGHTS_FETCH_AND_SET_FLIGHTS, { originCode, destinationCode }),
      ]);
      commit(MUTATION_TYPES.NIGHTS_SET_RESOURCES, [
        "origins",
        origins.map(o => {
          const { destinations, ...origin } = o;
          return origin;
        })
      ]);
      let { destinations, ...origin } = origins.find(
        ({ code }) => code === route.params.origin
      );
      if (!origin || !flights.length) {
        throw new Error("Not found");
      }
      commit(MUTATION_TYPES.NIGHTS_SET_STATE, ["origin", origin]);
      dispatch(ACTION_TYPES.NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS, destinations);
    }
  },
  [ACTION_TYPES.NIGHTS_FETCH_ORIGINS_WITH_DESTINATIONS](context) {
    return axios.get("/api/locations/more-than-one-day");
  },
  [ACTION_TYPES.NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS](
    { commit, state, getters },
    destinations
  ) {
    let flights = state.nights.resources.flights.map(el => {
      return el.cityCodeTo;
    });
    const destinationsWithFlights = destinations
      .filter(destination => flights.indexOf(destination.code) !== -1)
      .map(destination => {
        return {
          ...destination,
          image: destination.results_thumbnail_image,
          title: destination.name,
          price: getters[
            GETTER_TYPES.NIGHTS_GET_CHEAPEST_FLIGHT_TO_DESTINATION
          ](destination)
        };
      });
    commit(
      MUTATION_TYPES.NIGHTS_SET_DESTINATIONS_WITH_FLIGHTS,
      destinationsWithFlights
    );
  },
  async [ACTION_TYPES.NIGHTS_FETCH_AND_SET_FLIGHTS]({ commit, state, getters }, { originCode, destinationCode }) {
    const { start, end, adults, children, babies, itinerary, journey } = state.nights;
    const nights = getters[GETTER_TYPES.NIGHTS_GET_NIGHTS];

    let { data: flights } = await axios.get(
      `/api/flights/${originCode}${destinationCode ? ('/' + destinationCode) : ''}?startDate=${start}&endDate=${end}&nights=${nights}&adults=${adults}&children=${children}&infants=${babies}&itinerary=${itinerary}${journey ? `&journey=${journey}` : ''}`
    );
    if(flights.international) {
      commit('setBundlePrice', flights.bundlePrice);
      commit(MUTATION_TYPES.NIGHTS_SET_RESOURCES, ["internFlights", flights.internals]);
      flights = flights.international
    } else {
      commit(MUTATION_TYPES.NIGHTS_SET_PACK, false);
    }

    flights = flights.map(flight => ({
      ...flight,
      journeyFlightDepartureTime: moment(flight.journeyFlightDepartureTime),
      journeyFlightArrivalTime: moment(flight.journeyFlightArrivalTime),
      journeyFlightDuration: getFlightDurationText(flight, 'journey', destinationCode),
      returnFlightDepartureTime: moment(flight.returnFlightDepartureTime),
      returnFlightArrivalTime: moment(flight.returnFlightArrivalTime),
    }));
    commit(MUTATION_TYPES.NIGHTS_SET_RESOURCES, ["flights", flights]);
    return flights;
  },
  async [ACTION_TYPES.NIGHTS_FETCH_AND_SET_HOTELS](
    { commit, getters, state },
    { rooms = null, hotelCode = null }
  ) {
    commit(MUTATION_TYPES.NIGHTS_SET_STATE, ["hotel", {}]);
    const { nights } = state;

    let data;
    try {
      const response = await axios.get("/api/hotels", {
        params: {
          latitude: nights.destination.latitude,
          longitude: nights.destination.longitude,
          checkIn: nights.start,
          checkOut: nights.end,
          rooms: rooms || nights.rooms,
          adults: nights.adults,
          children: nights.children,
          childrenAges: nights.passengers.filter((p) => p.type === "child").map((children) => children.age).join('-'), // TODO
          babies: nights.babies,
          babiesAges: nights.passengers.filter((p) => p.type === "baby").map((baby) => baby.age).join('-'), // TODO
          locationId: nights.destination.id,
          ...(hotelCode ? { hotelCode } : {}),
        }
      });
      data = response.data;
    } catch (e) {
      throw new Error(e.response.status === 404 ? 'No hotels found' : 'Error fetching hotels');
      return;
    }

    let hotels = data.hotels.hotels;
    if (!hotels.length) {
      throw new Error("No hotels found");
    }

    hotels = hotels.map(hotel => ({
      ...hotel,
      price: getters[GETTER_TYPES.NIGHTS_GET_HOTEL_PRICE](hotel),
    }));

    commit(MUTATION_TYPES.NIGHTS_SET_RESOURCES, ["hotels", hotels]);
  },
  async [ACTION_TYPES.NIGHTS_RECHECK_HOTEL_AND_SET_FINAL_PRICE]({
    commit,
    state,
    getters
  }) {
    if (_.isEmpty(state.nights.hotel)) {
      return;
    }

    // Recheck shouldn't be made if rateType is 'BOOKABLE',
    // but availability net price and recheck net price don't seem to match
    const { hotel } = state.nights;
    let rateComments = hotel.rateComments || [];
    const rates = hotel.rooms.flatMap(({ rates }) => rates);

    /** Per Hotelbeds, BOOKABLE rates are not supposed to need a recheck, but then rate comments will not be shown
        to the user before their payment. Always rechecking might just be safer. If next line is left
        uncommented, commented out line with .filter below should also be uncommented */
    // const bookableRates = rates.filter(({ rateType }) => rateType === 'BOOKABLE');
    const bookableRates = [];

    let price = bookableRates.reduce((total, curr) => total += getters[GETTER_TYPES.NIGHTS_GET_RATE_PRICE](curr), 0);

    const recheckRateKeys = rates
      // .filter(({ rateType }) => rateType === 'RECHECK') // Just recheck every single rate
      .map(({ rateKey }) => rateKey).join(',');

    if (recheckRateKeys) {
      const { data } = await axios.get(
        `/api/hotels/recheck/${recheckRateKeys}`
      );

      if (data.error) {
        throw new Error("Error during hotel recheck");
        return;
      }

      price = data.hotel.totalNet;

      rateComments = data.hotel.rooms
        .flatMap(({ rates }) => rates)
        .reduce((agg, { rateComments }) => {
          if (!rateComments) return agg;
          return [...agg, { description: rateComments }];
        }, rateComments);
    }

    commit(MUTATION_TYPES.NIGHTS_SET_STATE, [
      "hotel",
      { ...hotel, price, rateComments }
    ]);
  },
  async [ACTION_TYPES.NIGHTS_FETCH_AND_SET_EXTRAS]({ commit, state }, payload) {
    const { code, airlines } = { ...payload };

    const { data } = await axios.get(
      `/api/extras?destination=${code}&providers=${airlines}`
    );
    commit(MUTATION_TYPES.NIGHTS_SET_RESOURCES, ["extras", data]);
  },
  async [ACTION_TYPES.SET_JOURNEY_FLIGHT]({ commit, state }, payload) {
    commit(MUTATION_TYPES.SET_JOURNEY_FLIGHT, payload);
    const originCode = state.nights.origin.code;
    const destinationCode = state.nights.destination.code;

    const { start, end, adults, children, babies, itinerary } = state.nights;
    const departureToken = payload.departureToken;

    let {data: flights} = await axios.get(
      `/api/flights/${originCode}/${destinationCode}?startDate=${start}&endDate=${end}&adults=${adults}&children=${children}&infants=${babies}&itinerary=${itinerary}&journey=true&departureToken=${departureToken}`
    );

    flights = flights.international.map(flight => ({
      ...flight,
      journeyFlightDepartureTime: moment(flight.journeyFlightDepartureTime),
      journeyFlightArrivalTime: moment(flight.journeyFlightArrivalTime),
      journeyFlightDuration: getFlightDurationText(flight, 'journey', destinationCode),
      returnFlightDepartureTime: moment(flight.returnFlightDepartureTime),
      returnFlightArrivalTime: moment(flight.returnFlightArrivalTime),
    }));
    commit(MUTATION_TYPES.NIGHTS_SET_RESOURCES, ["returnFlights", flights]);
  },
  async [ACTION_TYPES.SET_RETURN_FLIGHT]({ commit, state }, payload) {
    return new Promise((resolve, reject) => {

    commit(MUTATION_TYPES.SET_RETURN_FLIGHT, payload);
    const originCode = state.nights.origin.code;
    const destinationCode = state.nights.destination.code;

    const { start, end, adults, children, babies, itinerary } = state.nights;
    const bookingToken = payload.bookingToken;

      axios.get(
        `/api/flights/${originCode}/${destinationCode}?startDate=${start}&endDate=${end}&adults=${adults}&children=${children}&infants=${babies}&itinerary=${itinerary}&journey=true&bookingToken=${bookingToken}`
      ).then(({data}) => {
        let flights = data;

        flights = flights.international.map(flight => ({
          ...flight,
          journeyFlightDepartureTime: moment(flight.journeyFlightDepartureTime),
          journeyFlightArrivalTime: moment(flight.journeyFlightArrivalTime),
          journeyFlightDuration: getFlightDurationText(flight, 'journey', destinationCode),
          returnFlightDepartureTime: moment(flight.returnFlightDepartureTime),
          returnFlightArrivalTime: moment(flight.returnFlightArrivalTime),
        }));
        const flightSelected = flights[0];
        flightSelected.definitive = true;

        commit(MUTATION_TYPES.NIGHTS_SET_FLIGHT, flights[0])
        resolve({status: 200});

      }).catch(error => {
        reject({status: 400});
      });
    })
  },

  [ACTION_TYPES.FETCH_DESTINATION_CARDS]({ commit, state }) {
    if (state.nights.resources.destinationCards.length > 0) {
      return;
    }

    return axios.get("/api/destination-cards")
      .then(({ data }) => {
        const formattedData = data.data.map(dest => ({
          title: dest.title,
          image: dest.image,
          altImage: dest.alt_image,
          titleImage: dest.title_image,
          link: dest.link,
          isVueRoute: true
        }));

        commit(MUTATION_TYPES.SET_DESTINATION_CARDS, formattedData);
      })
      .catch(error => {
        console.error("Error al obtener destinos:", error);
      });
  },


  async fetchItineraries({ commit }, locationCode) {
      try {
        const response = await axios.get(`/api/itineraries/${locationCode}`);
        commit('SET_ITINERARIES', response.data);
      } catch (error) {
        console.error("Error al obtener itinerarios:", error);
      }
  },

  async fetchHotelsAndItinerary({ commit }, { locationCode, start, itinerary }) {
    try {
      //TODO(cards): Review different trips
      const response = await axios.get(`/api/hotels-and-itinerary/${locationCode}`, {
        params: {
          start,
          itinerary
        }
      });
      const {hotelsByLocation, totalPrice, totalPriceLuxury, luxuryExtra, extraNoPromoPrice } = response.data;
      commit(MUTATION_TYPES.NIGHTS_SET_PACK_HOTELS, hotelsByLocation);
      commit(MUTATION_TYPES.NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_STANDARD, totalPrice);
      commit(MUTATION_TYPES.NIGHTS_SET_TOTAL_PRICE_HOTELS_PACK_LUXURY, totalPriceLuxury);
      commit(MUTATION_TYPES.NIGHTS_SET_LUXURY_EXTRA, luxuryExtra);
      commit(MUTATION_TYPES.NIGHTS_SET_EXTRA_NO_PROMO_PRICE, extraNoPromoPrice);
      return Promise.resolve();
    } catch (error) {
      console.error('Error al obtener hoteles y itinerario:', error);
      return Promise.reject(error);
    }
  },




};
